module.exports = __webpack_public_path__ + "img/oil-refinery-fire.92d1107a.png";